import script from "./Step.vue?vue&type=script&setup=true&lang=ts"
export * from "./Step.vue?vue&type=script&setup=true&lang=ts"

import "./Step.vue?vue&type=style&index=0&id=3e08d4f9&lang=css"

export default script